import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, HostListener, Input, Output, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-dropdown',
  standalone: true,
  templateUrl: './dropdown.component.html',
  styleUrl: './dropdown.component.scss',
  imports: [CommonModule, FormsModule]
})
export class DropdownComponent {
  @Input() organizationKey: string = "";
  @Input() projectKey: string = "";
  @Input() userId: string = "";
  @Input() fieldKey: string = "";
  @Input() contentKey: string = "";
  @Input() aggregatedContent: string = "";
  @Input() fullWidth: boolean = true;
  @Input() content = "";
  @Input() label: string = "";
  @Input() isReadOnly: boolean = false;
  isMultichoice: boolean = false;
  selected: number = 0;
  isPersonaDropdown: boolean = false;
  obj: { "selected": number, "label": string, "options": { "label": string, "selected": boolean }[], "isMultichoice": boolean , "isPersonaDropdown": boolean } = { "selected": 0, "label": "", "options": [], "isMultichoice": false, "isPersonaDropdown": false };
  @Output() valueChange = new EventEmitter<{ "content": string, "fieldKey": string }>();
  showOptions = false;
  options: { "label": string, "selected": boolean }[] = [];
  @ViewChild('dropdown', { static: true }) dropdown!: ElementRef<HTMLDivElement>;

  ngAfterViewInit() {
    if (this.content != "") {
      this.convertToObject()
    }
  }

  convertToObject() {
    this.obj = JSON.parse(this.content)
    this.selected = this.obj.selected || 0
    this.label = this.obj.label || this.label || ""
    this.options = this.obj.options || []
    this.isMultichoice = this.obj.isMultichoice || false
    this.isPersonaDropdown = this.obj.isPersonaDropdown || false
  }

  convertToJson() {
    this.obj.selected = this.selected
    this.obj.label = this.label
    this.obj.options = this.options
    this.content = JSON.stringify(this.obj);
  }

  get selectedLabel(): string {
    if (this.isMultichoice == true) {
      return this.options.filter(option => option.selected).map(option => option.label).join(", ");
    } else {
      if (this.options[this.selected]) {
        return this.options[this.selected].label || "";
      }
      return "";
    }
  }

  toggleDropdown() {
    this.showOptions = !this.showOptions;
  }

  selectOption(idx: number) {
    if (this.isReadOnly == true) {
      return
    }
    this.selected = idx;
    if (this.isMultichoice == true) {
      this.options[idx].selected = !this.options[idx].selected;
    } else {
      this.options.forEach(option => {
        option.selected = false;
      });
      this.options[idx].selected = true;
    }
    this.convertToJson()
    this.valueChange.emit({ "content": this.content, "fieldKey": this.fieldKey });
    if (this.isMultichoice == false) {
      this.showOptions = false;
    }
  }

  @HostListener('document:mousedown', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (this.showOptions && !this.dropdown.nativeElement.contains(event.target as Node)) {
      this.showOptions = false;
    }
  }

}
